module.exports = __webpack_public_path__ + "static/red_knight-symbol-SCAG-852cabba32995059c496805ffe923416.png";